<script lang="ts">
  import { page } from '$app/stores';

  import { SaleOrderStatus, TokenStatus } from '@do/models';

  import { Button } from '@shared/ui/buttons/button';
  import { DefendBox } from '@shared/ui/defend-box';
  import { PurchaseTip } from '@shared/ui/purchase-tip';

  import type { ArtAsset } from '@entities/art-asset';
  import { purchaseModel, PurchaseState } from '@entities/purchase';

  import { ArtworkPurchase } from '@features/purchase/purchase-artwork';
  import { purchaseConfig } from '@features/purchase/purchase-form';
  import { PurchaseInfo } from '@features/purchase/purchase-info';

  import Heading from './heading.svelte';

  export let artwork: ArtAsset;
  export let purchaseForm: purchaseConfig.PurchaseForm;

  $: artworkPrice = artwork.sale_order?.price_formatted || artwork.estimate_price || artwork.realized_price;
</script>

<div class="mb-8 lg:max-w-[656px] xl:max-w-full">
  <div class="flex flex-col">
    <Heading artAsset="{artwork}" />
  </div>

  <div>
    {#if artwork.token_status === TokenStatus.OnAuction && artwork.auction?.id}
      <Button href="/auction-{artwork.auction?.id}/" iconName="auctions">
        <span class="text-sm">View on Auction Page</span>
      </Button>
    {:else}
      <ArtworkPurchase
        formData="{purchaseForm}"
        artworkName="{artwork.name_english}"
        artist="{artwork.artists.map((artist) => artist.name).join(', ')}"
        formAction="?/purchase"
        price="{artworkPrice}"
        tokenId="{artwork.token_id}"
        owner="{artwork.token_owner}"
        date="{artwork.latest_transfer_timestamp}"
        saleOrder="{artwork.sale_order}"
        isSoldOnAuction="{Boolean(artwork.token_status === TokenStatus.Sold && artwork.auctions?.length)}"
      />
    {/if}
  </div>

  {#if artwork.sale_order?.status === SaleOrderStatus.Placed}
    {#if $purchaseModel.state === PurchaseState.Approval || $purchaseModel.state === PurchaseState.Pending}
      <div class="mt-5">
        <PurchaseTip state="{$purchaseModel.state}" purchaseType="purchase" />
      </div>
    {/if}

    <div class="mt-5 flex flex-col items-center gap-4 md:gap-5 xl:items-start">
      <PurchaseInfo />
    </div>

    {#if $page.data.isUFDA}
      <DefendBox classes="my-8" />
    {/if}
  {/if}
</div>
